import { Button, Tooltip, Stack } from "@mui/material";
import React from "react";
import DrawIcon from "@mui/icons-material/Draw";
import SignatureDialog from "../Dialogs/SignatureDialog";

export default function SignatureControl(props) {
  const [isOpen, setIsOpen] = React.useState(false);

  const applySig = () => {
    setIsOpen(true);
  };

  return (
    <div>
      <Stack
        direction="column"
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        {props.value && props.value !== "" && (
          <img
            src={props.value}
            // src="https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2FDq28jacVxMPfVsyPPGDJPUXooO13%2Fprojects%2Fe84hsv2i6r33912ui9nw%2Fheader.png?alt=media&token=9d942ca9-d79a-4209-bb7e-e799869c7f41"
            alt="Signature"
          />
        )}
        <Tooltip title="Click to sign">
          <Button
            fullWidth
            variant="outlined"
            onClick={applySig}
            startIcon={<DrawIcon />}
          >
            Sign
          </Button>
        </Tooltip>
      </Stack>

      <SignatureDialog
        importTitle={props.importTitle}
        importSubtitle="Please sign below"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onChange={props.onChange}
        value={props.value}
        id={props.id}
        onClearSignature={props.onClearSignature}
      />
    </div>
  );
}
